import { Platform } from 'react-native';

export const createShadow = (
	x: number,
	y: number,
	blurRadius: number,
	spreadRadius: number,
	color: string,
) => {
	return Platform.select({
		web: {
			boxShadow: `${x}px ${y}px ${blurRadius}px ${spreadRadius}px ${color}`,
		},
		default: {
			shadowOffset: {
				width: x,
				height: y,
			},
			shadowRadius: blurRadius,
			shadowColor: color,
			elevation: blurRadius,
		},
	});
};

const drop1 = createShadow(0, 0, 12, 0, 'rgba(42, 50, 67, 0.15)');
const drop2 = createShadow(0, 0, 12, 0, 'rgba(42, 50, 67, 0.07)');
const drop3 = createShadow(0, 0, 6, 0, 'rgba(0, 0, 0, 0.15)');
const reset = createShadow(0, 0, 0, 0, 'rgba(0, 0, 0, 0)');

export const shadows = {
	drop1,
	drop2,
	drop3,
	reset,
};
